import * as React from 'react';

import MentionCardInformation from 'components/mention-card/mention-card-information/MentionCardInformation';

import { getTruncatedValue } from 'components/mention-card/utils/mention-card';

class MentionCardInformationYoutube extends MentionCardInformation {
  renderVideoTitle(): React.ReactNode | undefined | null {
    const { post, maxRowCount } = this.props;
    const value = post && post.videoTitle;
    const truncatedValue = getTruncatedValue(value, maxRowCount, 'videoTitle');

    return this.renderSection('label_video_title', truncatedValue);
  }

  renderVideoDescription(): React.ReactNode | undefined | null {
    const { post, maxRowCount } = this.props;
    const value = post && post.videoDescription;
    const truncatedValue = getTruncatedValue(value, maxRowCount, 'videoDescription');

    return this.renderSection('label_video_description', truncatedValue);
  }

  render(): React.ReactNode {
    return (
      <div
        className="mention-card-information mention-card-information--youtube"
        data-qa="mention-card-information-youtube"
      >
        {this.renderVideoTitle()}
        {this.renderKeywords('hashtags')}
        {this.renderVideoDescription()}
      </div>
    );
  }
}

export default MentionCardInformationYoutube;
